import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatagridService } from '../../../../shared/index';
import { PagedResult } from '../../../../shared/model/generic-paged-result.model';
import { NavigationService } from '../../../../shared/navigation/navigation.service';
import { MassCommService, Message, SentMessageStatistics, ClickLogSearch, ClickLog } from '../../../shared/index';

/**
 * message analytics (for not-drafts)
 */
@Component({
  selector: 'wl-mass-comm-message-edit-analytics-click-details',
  templateUrl: 'mass-comm-message-edit-analytics-click-details.component.html',
  styleUrls: [],
  providers: [],
    standalone: false
})
export class MassCommMessageEditAnalyticsClickDetailsComponent {
  @Input() public messageId: number = 0;
  @Input() public url: string = '';

  public isSearching: boolean = false;
  public isExporting: boolean = false;

  public clickLogResult: PagedResult<Array<ClickLog>> = new PagedResult<Array<ClickLog>>([]);

  private _searchParams: ClickLogSearch = new ClickLogSearch();

  /**
   * inject
   */
  public constructor(
    private _massCommService: MassCommService,
    private _navigationService: NavigationService,
    private _datagridService: DatagridService
  ) {}

  /**
   * for the ngprime data table
   */
  public lazyLoad($event: any): void {
    this._datagridService.mapDatagridPagingToPagedSearch($event, this._searchParams);

    if (!this.isSearching) this.getClickLogs();
  }

  /**
   * user wants to export
   */
  public handleExportToExcelClick(): void {
    this.exportDetailsToExcel();
  }

  /**
   * load recipients for grid
   */
  private async getClickLogs(): Promise<void> {
    if (this.isSearching || this.messageId <= 0) return;

    this.isSearching = true;

    this._searchParams.MessageId = this.messageId;
    this._searchParams.Url = this.url;

    try {
      let result: PagedResult<Array<ClickLog>> = await this._massCommService.searchClickLogs(this._searchParams);

      if (result) {
        this._datagridService.mapPagedResultsToPagedSearch(result, this._searchParams);
        this.clickLogResult = result;
      } else {
        this.clickLogResult.Result = [];
      }
    } catch (e) {
    } finally {
      this.isSearching = false;
    }
  }

  /**
   * export to excel
   */
  private async exportDetailsToExcel(): Promise<void> {
    if (this.isExporting) return;

    this.isExporting = true;

    try {
      let url: string = await this._massCommService.exportClickLogsAsExcel(this._searchParams);

      this._navigationService.popupSafeNavigate(url);
    } catch (e) {
    } finally {
      this.isExporting = false;
    }
  }
}
